import { useCallback } from "react";
import { useHistory } from "react-router";

import { useBandContext, useEventContext } from "Bands/contexts";
import { buildUrl } from "shared/utils";
import { BAND_PATHS } from "Bands/router";

export const useEventRoute = () => {
  const history = useHistory();
  const { bandId } = useBandContext();
  const { eventId } = useEventContext();

  const pushRoute = useCallback(
    (
      path: string,
      options?: {
        eventId?: string;
        hash?: string;
        params?: Record<string, string>;
      }
    ) => {
      (eventId || options?.eventId) &&
        history.push(
          buildUrl(
            path,
            {
              eventId: (options?.eventId || eventId) as string,
              bandId: bandId as string,
              ...options?.params,
            },
            options?.hash
          )
        );
    },
    [eventId, history, bandId]
  );

  const getPath = useCallback(
    (path: string, options?: { eventId?: string; hash?: string }) => {
      if (eventId || options?.eventId) {
        return buildUrl(
          path,
          {
            eventId: (options?.eventId || eventId) as string,
            bandId: bandId as string,
          },
          options?.hash
        );
      }
      return BAND_PATHS.HOME;
    },
    [eventId, bandId]
  );

  return { pushRoute, getPath };
};
